import * as types from '../actiontypes';
import env from '../../util/env';
import {documentTypes, OperationTypes, serviceURL} from '../../util/uiconstants';
import {submitIndependenceTemplateUrl} from '../apiUrls';

import {API_RESOURCES, createApiReadAction} from '../../util/api';
import Env from '../../util/env';

export const getFormData = (url, params = {}) => {
	return {
		type: types.GET_FORM_DATA,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		...params
	};
};

export const updateFormDataAfterBodyResponse = (formData) => {
	return {
		type: types.GET_FORM_DATA,
		response: formData
	};
};

export const getFormProfileDataById = (engagementId, formId) => {
	return createApiReadAction(
		types.GET_FORM_PROFILE_DATA_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: formId
		},
		{expand: 'profile'}
	);
};

export const updateFormProfileResponse = (url, resource) => {
	return {
		type: types.UPDATE_FORM_PROFILE_RESPONSE,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const getFormBodiesBySectionId = (url) => {
	return {
		type: types.GET_FORM_BODIES_BY_SECTIONID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getFormBodiesByBodyTypeId = (engagementId, documentId, headerId, sectionId, queryParams) => {
	return createApiReadAction(
		types.GET_FORM_BODIES_BY_BODYTYPEID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: documentId,
			[API_RESOURCES.FORMS.HEADERS]: headerId,
			[API_RESOURCES.FORMS.SECTIONS]: sectionId,
			[API_RESOURCES.FORMS.BODIES]: undefined
		},
		queryParams
	);
};

export const updateFormBodyResponseNoSaga = (url, resource) => {
	return {
		type: types.UPDATE_FORM_BODY_RESPONSE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const updateFormBodyResponse = (url, resource) => {
	/*if (resource.bodyTypeId !== formBodyType.TextResponse && resource.bodyTypeId !== formBodyType.InlineRichText) {
		Utility.increaseSaveBodyCount();
	}
	return {type: types.UPDATE_FORM_BODY_RESPONSE_SAGA, url: url, resource: resource};*/
	return {
		type: types.UPDATE_FORM_BODY_RESPONSE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: resource
			}
		}
	};
};

export const getFormBodiesAfterProcessingResponse = (formBodyData, sectionId) => {
	return {
		type: types.GET_FORM_BODIES_AFTER_RESPONSE,
		response: formBodyData,
		sectionId: sectionId
	};
};

export const updateFormBodyResponseNoStoreUpdate = (url, payload) => {
	return {
		type: types.UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: payload
			}
		}
	};
};

export const deleteFormBody = (url, bodyId) => {
	return {
		type: types.DELETE_FORM_BODY,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		bodyId: bodyId
	};
};

export const duplicateSection = (url, data, sectionId) => {
	return {
		type: types.CREATE_DUPLICATE_SECTION,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		},
		sectionId: sectionId
	};
};

export const deleteSection = (url, data) => {
	return {
		type: types.DELETE_SECTION,
		meta: {
			api: {
				url: url,
				method: 'DELETE',
				data: data
			}
		}
	};
};

export const deleteHeader = (url, data) => {
	return {
		type: types.DELETE_HEADER,
		meta: {
			api: {
				url: url,
				method: 'DELETE',
				data: data
			}
		}
	};
};

export const addCustom = (url, data) => {
	return {
		type: types.CREATE_CUSTOM,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

export const addCustomBody = (url, data) => {
	return {
		type: types.ADD_CUSTOM_BODY,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

export const editSection = (url, data) => {
	return {
		type: types.EDIT_SECTION,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const editBody = (url, data) => {
	return {
		type: types.EDIT_BODY,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const editHeader = (url, data) => {
	return {
		type: types.EDIT_HEADER,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: data
			}
		}
	};
};

export const submitIndependence = (url, data) => {
	return {
		type: types.SUBMIT_INDEPENDENCE,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const clearProfileData = () => {
	return {
		type: types.CLEAR_PROFILE_DATA
	};
}

export const submitProfile = (engagementId, documentId, data) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Forms/${documentId}/SubmitProfile`;

	return {
		type: types.SUBMIT_PROFILE,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const submitIndependenceAction = (engagementId, userId, operationType, data) => {
	const url =
		env.getBaseURL(serviceURL, engagementId) +
		'InternalUsers/' +
		userId +
		'/IndependenceAction?independenceAction=' +
		operationType;

	return {
		type: types.SUBMIT_INDEPENDENCE_ACTION,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const submitIndependenceTemplate = (engagementId, documentId, requestBody = {}) => {
	let url = submitIndependenceTemplateUrl(engagementId, documentId);

	return {
		type: types.SUBMIT_INDEPENDENCE_TEMPLATE,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: requestBody
			}
		}
	};
};

export const overwriteForm = (url, data) => {
	return {
		type: types.OVERWRITE_FORM,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export function updateStoreForFormDataNoSaga(data) {
	return {
		type: types.UPDATE_RICH_TEXT_BODY,
		data: {
			id: data.id,
			bodyFreeText: data.isConflict ? data.currentBodyFreeText : data.bodyFreeText,
			concurrencyToken: data.concurrencyToken,
			isConflict: data.isConflict
		}
	};
}

export const updateBodyFreeText = (bodyId, bodyFreeText, bodyTypeId, concurrencyToken, discardChanges) => {
	return {
		type: types.UPDATE_BODY_FREE_TEXT,
		data: {
			id: bodyId,
			bodyFreeText: bodyFreeText,
			bodyTypeId: bodyTypeId,
			concurrencyToken: concurrencyToken,
			discardChanges: discardChanges
		}
	};
};

export const updateOnConflict = (bodyId, conflictResponse) => {
	return {
		type: types.UPDATE_BODY_ON_CONFLICT,
		data: {id: bodyId, conflictResponse: conflictResponse}
	};
};

export function updateFormBodyRelatedObject(data, operationType = OperationTypes.update) {
	return {
		type: types.UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE,
		operationType,
		response: data
	};
}

export function updateFormBodyRelatedDocCount(id, relatedDocCount) {
	return {
		type: types.UPDATE_BODY_RELATED_COUNT,
		data: {id: id, relatedDocCount: relatedDocCount}
	};
}

export const createUserIndependenceForm = (url) => {
	return {
		type: types.CREATE_INDEPENDENCE_FORM,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: {documentTypeId: documentTypes.INDEPENDENCEFORMINDIVIDUAL}
			}
		}
	};
};

export function updateStoreForFormBodyRiskFactors(bodyId, riskId, riskCustomDescription) {
	return {
		type: types.UPDATE_FORMBODY_RISKFACTORS,
		bodyId: bodyId,
		riskId: riskId,
		riskCustomDescription: riskCustomDescription
	};
}

export function getFormBodyGuidances(engagementId, documentId, sectionId, bodyId, guidanceTypeIds = [], trackWithArea) {
	const query = guidanceTypeIds.reduce((acc, id) => {
		if (acc) {
			acc += '&';
		}

		return `${acc}filterGuidanceTypeIds=${id}`;
	}, '');

	let url = `${Env.getBaseURL(serviceURL, engagementId)}Forms/${documentId}/Body/${bodyId}/Guidances`;

	if (guidanceTypeIds.length > 0) {
		url += `?${query}`;
	}

	return {
		type: types.GET_BODY_GUIDANCES,
		meta: {
			api: {
				url,
				method: 'GET',
				trackWithArea
			}
		},
		sectionId,
		bodyId
	};
}
